import React, { useState } from 'react'
import styled, { css } from 'styled-components'
import AniLink from 'gatsby-plugin-transition-link/AniLink'

import Button from '../Button'
import SubscribeBox from '../SubscribeBox'

import giftIcon from '../../assets/images/gold-gift.webp'

import Popup from '../Popup'

const SubscribeButton = styled.button`
  position: absolute;
  z-index: 899;
  top: ${({ giftCards }) => giftCards ? `42px;` : `2px;` }
  right: 20px;
  right: ${({ giftCards }) => giftCards ? `-5px;` : `-5px;` }
  overflow: hidden;
  display: inline-flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-end;
  min-width: 135px;
  margin: 0;
  padding: 9px 15px;
  border: 2px solid #a98e67;
  border-radius: 8px;
  font-size: 14px;
  ${({ theme, black }) => black && `background: ${theme.colors.black};`}
  color: #FFF;
  cursor: pointer;

  :before {
    content: '';
    z-index: -1;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 0;
    background: ${({ theme, white }) =>
      white ? theme.colors.white : theme.colors.primary};
    transition: height 0.3s ease;
  }

  :hover:before {
    height: 100%;
  }

  & + & {
    margin-left: 16px;
  }
  
  ${({ theme, white }) =>
    white &&
    css`
      :hover span {
        color: ${theme.colors.primary};
      }
    `}

  ${({ theme }) => theme.media.l} {
    padding: 11px 17px;
    font-size: 14px;
    right: ${({ giftCards }) => giftCards ? `185px;` : `20px;` }
    top: -3px;
  }

  ${({ theme }) => theme.media.xl} {
    padding: 14px 20px;
    font-size: 16px;
    right: ${({ giftCards }) => giftCards ? `185px;` : `20px;` }
    top: -3px;
  }

  ${({ theme }) => theme.media.xxl} {
    padding: 20px 30px;
    font-size: 22px;
    right: ${({ giftCards }) => giftCards ? `250px;` : `20px;` }
    top: -3px;
  }
`

const SubscribeButton2 = styled.a`
  position: absolute;
  z-index: 899;
  top: ${({ giftCards }) => giftCards ? `42px;` : `2px;` }
  right: 20px;
  right: ${({ giftCards }) => giftCards ? `-5px;` : `-5px;` }
  overflow: hidden;
  display: inline-flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-end;
  min-width: 135px;
  margin: 0;
  padding: 9px 15px;
  border: 2px solid #a98e67;
  border-radius: 8px;
  font-size: 14px;
  ${({ theme, black }) => black && `background: ${theme.colors.black};`}
  color: #FFF;
  cursor: pointer;

  :before {
    content: '';
    z-index: -1;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 0;
    background: ${({ theme, white }) =>
      white ? theme.colors.white : theme.colors.primary};
    transition: height 0.3s ease;
  }

  :hover:before {
    height: 100%;
  }

  & + & {
    margin-left: 16px;
  }
  
  ${({ theme, white }) =>
    white &&
    css`
      :hover span {
        color: ${theme.colors.primary};
      }
    `}

  ${({ theme }) => theme.media.l} {
    padding: 11px 17px;
    font-size: 14px;
    right: ${({ giftCards }) => giftCards ? `185px;` : `20px;` }
    top: -3px;
  }

  ${({ theme }) => theme.media.xl} {
    padding: 14px 20px;
    font-size: 16px;
    right: ${({ giftCards }) => giftCards ? `185px;` : `20px;` }
    top: -3px;
  }

  ${({ theme }) => theme.media.xxl} {
    padding: 20px 30px;
    font-size: 22px;
    right: ${({ giftCards }) => giftCards ? `250px;` : `20px;` }
    top: -3px;
  }
`

const Wrapper = styled.section`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: flex-start;
  margin: 0;
  padding: 0;
  width: 100%;
  min-height: 100vh;
  transition: all 0.3s ease;
  ${({ theme }) => theme.media.m} {
    min-height: 100vh;
  }
`

const BackgroundImage = styled.figure`
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: -15%;
  width: 115%;
  height: 95%;
  background: top left no-repeat;
  background-size: cover;

  opacity: 0;

  -webkit-animation-name: fade, heroMoveSlide;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-duration: ${({ totalDuration }) => totalDuration}s;
  
  animation-name: fade, heroMoveSlide;
  animation-iteration-count: infinite;
  animation-duration: ${({ totalDuration }) => totalDuration}s;

  background-image: url(${({ image }) => image});

  -webkit-animation-delay: ${({ delay }) => delay}s;

  :before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 30%;
    background: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0.65) 28%,
      rgba(0, 0, 0, 0) 100%
    );
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#a6000000', endColorstr='#00000000',GradientType=0 );
    opacity: 0.7;
  }
  :after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 30%;
    background: linear-gradient(
      to top,
      rgba(19, 19, 19, 1) 25%,
      rgba(19, 19, 19, 0) 100%
    );
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#a6000000', endColorstr='#00000000',GradientType=0 );
  }
  
`

const Container = styled.div`
  position: absolute;
  top: 150px;
  left: 0;
  width: 100%;
  text-align: center;
  ::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    overflow: visible;
    width: 100%;
    height: 90%;
    background: radial-gradient(
      ellipse at center,
      rgba(44, 43, 42, 0.65) 0%,
      rgba(44, 43, 42, 0.48) 39%,
      rgba(44, 43, 42, 0) 72%
    );
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#a62c2b2a', endColorstr='#002c2b2a',GradientType=1 );
    opacity: 0.7;
  }
  ${({ theme }) => theme.media.m} {
    top: 180px;
    left: 50%;
    width: 750px;
    margin-left: -375px;
  }
  ${({ theme }) => theme.media.l} {
    top: 210px;
  }
  ${({ theme }) => theme.media.xl} {
    top: 265px;
  }
  ${({ theme }) => theme.media.xxl} {
    top: 370px;
  }
`

const BottomContainer = styled.div`
  position: relative;
  padding: 600px 50px 250px;
  width: 100%;
  max-width: ${({ theme }) => theme.sizes.maxContentWidth};
  ${({ theme }) => theme.media.m} {
    padding: 650px 50px 250px;
  }
  ${({ theme }) => theme.media.l} {
    padding: 700px 50px 250px;
  }
  ${({ theme }) => theme.media.xl} {
    padding: 720px 50px 250px;
  }
  ${({ theme }) => theme.media.xxl} {
    padding: 850px 50px 250px;
  }
`

const ContainerInner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  padding: 0 10px;
  width: 100%;
  max-width: ${({ theme }) => theme.sizes.maxContentWidth};
  > span {
    margin: 0 0 60px;
    font-size: 42px;
    font-weight: ${({ theme }) => theme.font.light};
  }
  h1 {
    position: relative;
    margin: 0 0 25px;
    font-size: 55px;
    line-height: 0.85;
    > span {
      display: block;
      font-weight: ${({ theme }) => theme.font.bold};
    }
  }
  p {
    margin: 0 0 25px;
    font-size: 18px;
    text-align: center;
    opacity: 1;
    text-shadow: 1px 1px 0 #000000;
    z-index: 1;
  }
  ${({ theme }) => theme.media.m} {
    h1 {
      font-size: 78px;
    }
  }
  ${({ theme }) => theme.media.l} {
    h1 {
      font-size: 80px;
      span {
        display: inline;
      }
    }
  }
  ${({ theme }) => theme.media.xl} {
    h1 {
      font-size: 88px;
    }
  }
  ${({ theme }) => theme.media.xxl} {
    h1 {
      font-size: 95px;
    }
  }
`

const FestiveButton = styled.div`
.button {
  margin-top: 15px;
	display: inline-block;
	-webkit-box-sizing:border-box;
	   -moz-box-sizing:border-box;
	        box-sizing:border-box;
	min-width:100px;
	padding: 20px 45px;
  font-family: Gotham;
  font-weight: 400;
  text-transform: uppercase;
	font-size: 18px;
	text-decoration: none;
	color: #FFF;
	background: #F5C5D0;
	outline: none;
	border-radius: 15px;
	border: none;
  z-index: 100;
	transition: all ease 0.3s;
	position: relative;
}

.button:hover {
	transform: scale(1.05);
} 
`

const Hero = ({ heroImages, bottomContainer, children }) => {

  const [formPopup, setFormPopup] = useState(false)

  const images = heroImages.map(
    item => item.node.image.childImageSharp.original?.src
  )

  let imagesCount = images.length;
  let duration = 5
  let transition = 2

  const t = imagesCount * (duration + transition)

  const p1 = Math.round(transition / t * 100)
  const p2 = Math.round((duration + transition) / t * 100)
  const p3 = Math.round(p2 * 1.6);

  let keyframesMove = `
    0% {opacity: 0;}
    ${p1}% {opacity: 0.5;}
    ${p2}% {opacity: 0.5;}
    ${p3}% {opacity: 0;}
    100% {opacity: 0;}
  `
  let keyframesHeroMove = `
    0% {
      transform: translate3d(0, 0, 0);
    }
    50% {
      transform: translate3d(10%, 0, 0);
    }
    100% {
      transform: translate3d(0, 0, 0);
    }
  `

  let keyframes = `
    @keyframes fade {
      ${keyframesMove}
    }
    @-webkit-keyframes fade {
      ${keyframesMove}
    }
    @keyframes heroMoveSlide {
      ${keyframesHeroMove}
    }
    @-webkit-keyframes heroMoveSlide {
      ${keyframesHeroMove}
    }
  `

  return (
    <Wrapper>
      <Popup
        active={formPopup === true}
        handleClose={() => setFormPopup(false)}
      >
        <SubscribeBox />
      </Popup>
      <SubscribeButton giftCards><AniLink cover direction="down" to="/giftcards"><img width="40" style={{ padding: "1px", marginTop: "-6px", marginRight: "5px" }} src={giftIcon} alt="gift" />Gift Cards</AniLink></SubscribeButton>
      <SubscribeButton2 href="https://member.sandshospitality.com" target="_blank">Join Our Club</SubscribeButton2>
      {images.map((img, key) =>
        <BackgroundImage key={key}
          style={{
            backgroundImage: `url(${img})`,
            animationDelay: `${(duration + transition) * key}s`
          }}
          totalDuration={t}
        />
      )}
      <style>{keyframes}</style>
      <Container>
        <ContainerInner>
          <h1 style={{ fontSize: '72px', lineHeight: '1.2' }}>S&S Hospitality</h1>
          <h2 style={{ fontSize: '24px', marginBottom: '20px', color: '#FFF', opacity: 1, 'z-index': 5, position: 'relative' }}>Redefining Hospitality, Exceeding Expectations</h2>
          <Button
            onClick={() =>
              document.getElementById('portfolio').scrollIntoView({
                behavior: 'smooth',
              })
            }
          >
            View restaurants & Bars
          </Button>
            {/* <AniLink cover to="/valentines-day" bg="#070B14" direction="down">
              <FestiveButton className='gotham w-400'>
                  <div className='button'>Valentines Day</div>
              </FestiveButton>
            </AniLink> */}
        </ContainerInner>
      </Container>
      <BottomContainer>{bottomContainer}</BottomContainer>
    </Wrapper>
  )
}

export default Hero